<template>
	<div id="app">
		<!-- <img src="./assets/logo.png"> -->
		<cx-head v-if="windowWidth > 768" />
		<!-- <img class="floatImg" src="../static/img/index/float.png" @click="gotoPage('activity')"> -->
		<router-view />
		<cx-foot class="max_window" v-if="windowWidth > 768" />
		<div v-else>
			<div class="bottom_view">
				<div class="footImg">
					<img class="" width="116" src="../static/img/index/ic_logo.png" />
				</div>
				<div class="bottom_item">
					<div class="bottom_item1" @click="isShow1 = !isShow1">
						<div>{{ $t('footer.aboutUs') }}</div>
						<img width="9" height="9" src="../static/img/index/ic_add.png" />
					</div>
					<div style="color:#9b9b9b;font-size:14px;text-align: left;margin-top:5px" class="" v-if="isShow1">
						<div style="line-height: 2;" @click="gotoPage('about')">{{ $t('footer.companyProfile') }}</div>
						<div style="line-height: 2;" @click="gotoPage('about')">{{ $t('footer.visionAndMission') }}</div>
						<div style="line-height: 2;" @click="gotoPage('about')">{{ $t('footer.history') }}</div>
						<div style="line-height: 2;" @click="gotoPage('about')">{{ $t('footer.corporateHonor') }}</div>
						<div style="line-height: 2;" @click="gotoPage('about')">{{ $t('footer.onlineVisit') }}</div>
					</div>
				</div>
				<div class="bottom_item">
					<div class="bottom_item1" @click="isShow2 = !isShow2">
						<div>{{ $t('footer.Win-win') }}</div>
						<img width="9" height="9" src="../static/img/index/ic_add.png" />
					</div>
					<div style="color:#9b9b9b;font-size:14px;text-align: left;margin-top:5px" class="" v-if="isShow2">
						<div style="line-height: 2;" @click="gotoPage('service')">{{ $t('footer.scenicCooperation') }}
						</div>
						<div style="line-height: 2;" @click="gotoPage('service')">{{ $t('footer.campAlliance') }}</div>
						<div style="line-height: 2;" @click="gotoPage('service')">{{ $t('footer.joinRv') }}</div>
						<div style="line-height: 2;" @click="gotoPage('service')">{{ $t('footer.guideCooperation') }}
						</div>
					</div>
				</div>
				<div class="bottom_item">
					<div class="bottom_item1" @click="isShow3 = !isShow3">
						<div>{{ $t('footer.yueniyou') }}</div>
						<img width="9" height="9" src="../static/img/index/ic_add.png" />
					</div>
					<div style="color:#9b9b9b;font-size:14px;text-align: left;margin-top:5px" class="" v-if="isShow3">
						<div style="line-height: 2;" @click="gotoPage('function')">{{ $t('footer.rvCamping') }}</div>
						<div style="line-height: 2;" @click="gotoPage('function')">{{ $t('footer.literature') }}</div>
						<div style="line-height: 2;" @click="gotoPage('function')">{{ $t('footer.navigationExperience')
						}}</div>
						<div style="line-height: 2;" @click="gotoPage('function')">{{ $t('footer.appDownload') }}</div>
					</div>
				</div>
				<div class="bottom_item">
					<div class="bottom_item1" @click="isShow4 = !isShow4">
						<div>{{ $t('footer.learnMore') }}</div>
						<img width="9" height="9" src="../static/img/index/ic_add.png" />
					</div>
					<div style="color:#9b9b9b;font-size:14px;text-align: left;margin-top:5px" class="" v-if="isShow4">
						<div style="line-height: 2;" @click="gotoPage('news')">{{ $t('footer.news') }}</div>
						<div style="line-height: 2;" @click="gotoPage('media')">{{ $t('footer.theme') }}</div>
						<div style="line-height: 2;" @click="gotoPage('view')">{{ $t('footer.perspective') }}</div>
					</div>
				</div>
				<div class="bottom_item">
					<div class="bottom_item1" @click="isShow5 = !isShow5">
						<div>{{ $t('footer.contactUs') }}</div>
						<img width="9" height="9" src="../static/img/index/ic_add.png" />
					</div>
					<div style="color:#9b9b9b;font-size:14px;text-align: left;margin-top:5px" class="" v-if="isShow5">
						<div style="line-height: 2;">{{ $t('footer.contactNumber') }}：4000-155-105</div>
						<div style="line-height: 2;">{{ $t('footer.administrativeHeadquarters') }}：{{
							$t('footer.addressText2') }}</div>
						<div style="line-height: 2;">{{ $t('footer.contactAddress') }}：{{ $t('footer.addressText') }}
						</div>
						<div style="margin-top: 10px;">
							<img width="90" src="../static/img/index/ic_code.png" />
						</div>
					</div>
				</div>
			</div>
			<div class="bottom_view_min">
				<div class="group text-222" style="font-size: 10px !important;">
					<!-- <span @click="goto1('https://www.ezagoo.net/')" style="cursor: pointer;">{{
					$t('footer.ezgGroup') }}</span>
					| <span @click="goto1('https://bjzchl.ezagooad.com/')" style="cursor: pointer;">{{
						$t('footer.zchl') }}</span> |  -->
					<span @click="gotoPageIndex(2)" style="cursor: pointer;">{{ $t('footer.ycty') }}</span> | <span
						@click="goto1('http://xb.hkstv.tv/fangchelvyou/')" style="cursor: pointer;">{{
							$t('footer.hongkongTV') }}</span>
				</div>
				<br />
				<br />
				Copyright © 2014-{{ year }} klch.cn
				<br />湖南快乐车行露营地投资发展有限公司 版权所有<br />
				<span @click="goto1('https://beian.miit.gov.cn')" style="cursor: pointer;">湘ICP备18019974号</span>
				<br /><span @click="goto1('https://tsm.miit.gov.cn/dxxzsp/')" style="cursor: pointer;">
					中华人民共和国增值电信业务经营许可证 湘B2-20200115</span>
				<br />
				<span><img width="93" @click="
					goto1(
						'https://cslz.saicjg.com/2430/authority?key=794ab44b45abfe51e5311694a741460f'
					)
					" style="margin-right:10px;cursor: pointer;display:none" src="../static/img/index/siteBase_cs.png" />
					<img style="display:none" width="25" src="../static/img/index/ic_ga.png" /></span>
				<span @click="
					goto1(
						'http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=43011202000697'
					)
					" style="cursor: pointer;">
					湘公网安备 43011202000697号</span>
			</div>
		</div>
	</div>
</template>

<script>
import cxHead from '@/components/cx-head.vue';
import cxFoot from '@/components/cx-foot.vue';
export default {
	name: 'App',
	components: {
		cxHead,
		cxFoot,
	},
	data() {
		//这里存放数据
		return {
			windowWidth: window.innerWidth,
			isShow1: false,
			isShow2: false,
			isShow3: false,
			isShow4: false,
			isShow5: false,
			year: '2023',
		};
	},
	created() {
		let date = new Date();
		this.year = date.getFullYear();
	},
	methods: {
		goto1(e) {
			// debugger
			// window.open(e, '_blank');
			window.location.href = e;
		},
		gotoPage(e) {
			this.$router.push(e);
		},
		gotoPageIndex(id) {
			this.$router.push({
				path: '/function',
				query: { id: id }
			});
		}
	}
};
</script>

<style scoped lang="scss">
/*网站黑白化*/

#app {
	font-family: 'PingFangSC-Regular', 'helvetica neue', tahoma, 'PingFang SC', 'microsoft yahei', arial,
		'hiragino sans gb', sans-serif;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
	text-align: center;
	color: #2c3e50;
	font-size: 14px;
	/* margin-top: 60px; */
	/* filter: grayscale(100%); 
    -webkit-filter: grayscale(100%);
    -moz-filter: grayscale(100%);
    -ms-filter: grayscale(100%);
    -o-filter: grayscale(100%);
    filter: url("data:image/svg+xml;utf8,#grayscale"); 
    filter:progid:DXImageTransform.Microsoft.BasicImage(grayscale=1);
    -webkit-filter: grayscale(1); */
}

img {
	object-fit: cover !important;
}

.floatImg {
	position: fixed;
	right: 10px;
	top: 40%;
	width: 50px;
	z-index: 999999;
	cursor: pointer;
	animation: zoom 1s infinite ease-in-out;
	-webkit-animation: zoom 1s infinite ease-in-out;
}



@keyframes zoom {
	0% {
		transform: scale(1);
	}

	50% {
		transform: scale(1.1);
	}

	100% {
		transform: scale(1);
	}
}

.navbar-dark .navbar-toggler-ico {
	/* display: none */
	background-image: url('../static/img/index/ic_fun1.png') !important;
}

@media (max-width: 768px) {
	h4 {
		font-weight: bold !important;
		font-style: oblique;
		font-size: 20px !important;
		color: #222 !important;
	}

	h3 {
		font-weight: bold !important;
		font-style: oblique;
		font-size: 20px !important;
		color: #222 !important;
	}

	.content {
		padding-bottom: 20px !important;
	}

	.max_window {
		display: none
	}

	.bottom_view_min {
		color: #999;
		font-size: 12px;
		width: 100%;
		line-height: 1.8;
		padding: 20px 10px;
	}

	.bottom_view {
		padding-top: 25px;

		.footImg {
			text-align: left;
			border-bottom: 0.5px solid #E5E5E5;
			margin: 0 12px;
			padding-bottom: 20px;
			margin-bottom: 20px;
		}
	}

	.bottom_item {
		margin: 0 17px;
		padding: 14px 0;
		border-bottom: 0.5px solid #E5E5E5;
		font-size: 16px;
	}

	.bottom_item1 {
		display: flex;
		justify-content: space-between;
		align-items: center;
	}
}


@media (min-width: 768px) {
	h4 {
		font-family: 'zxhjt';
		font-weight: bold !important;
		font-style: oblique;
		font-size: 30px !important;
		color: #222 !important;
	}

	.floatImg {
		width: 80px;
	}

	.max_window {
		display: block
	}
}
</style>


// WEBPACK FOOTER //
// src/App.vue